import React from 'react';
import './Redes.css';
import logo_fb from '../../../assets/images/redes/CIBA_logo-fb-04.png';
import logo_ig from '../../../assets/images/redes/CIBA_logo-ig-04.png';
import logo_wpp from '../../../assets/images/redes/CIBA_logo-wpp-04.png';

export const Redes = () => (
  <div className="RedesSection">
    <div className="lineaRedes">
      <a href="https://api.whatsapp.com/send?text=%C2%A1Hola!%20Quiero%20realizar%20una%20consulta.&phone=5493413720808"  target="_blank" rel="noreferrer" className="link_redes">
        <span className="span_redes">Whatsapp</span>
        <img alt='' src={logo_wpp} className="img_redes" />
      </a>
    </div>
    <div className="lineaRedes">
      <a href="https://www.instagram.com/cibaservicios/" target="_blank" rel="noreferrer" className="link_redes">
        <span className="span_redes">Instagram</span>
        <img alt='' src={logo_ig} className="img_redes" />
      </a>
    </div>
    <div className="lineaRedes">
      <a href="https://www.facebook.com/cibarosario/"  target="_blank" rel="noreferrer" className="link_redes">
        <span className="span_redes">Facebook</span>
        <img alt='' src={logo_fb} className="img_redes" />
      </a>
    </div>
  </div>
);
